import React, { useState } from "react";
import CalendarLib from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Link } from "react-router-dom";

const holidays = [
  { date: "2025-01-26", name: "Republic Day" },
  { date: "2025-03-17", name: "Holi" },
  { date: "2025-04-14", name: "Ambedkar Jayanti" },
  { date: "2025-08-15", name: "Independence Day" },
  { date: "2025-10-02", name: "Gandhi Jayanti" },
  { date: "2025-11-04", name: "Diwali" },
  { date: "2025-12-25", name: "Christmas" },
];

const exams = [
  { date: "2025-03-01", name: "Mid-Term Exam" },
  { date: "2025-09-01", name: "Final Term Exam" },
];

const monthlyTests = [
  "2025-01-10",
  "2025-02-10",
  "2025-03-10",
  "2025-04-10",
  "2025-05-10",
  "2025-06-10",
  "2025-07-10",
  "2025-08-10",
  "2025-09-10",
  "2025-10-10",
  "2025-11-10",
  "2025-12-10",
];

const AcademicCalendar = () => {
  const [date, setDate] = useState(new Date());

  const getTileContent = ({ date: d, view }) => {
    if (view !== "month") return null;
    const iso = d.toISOString().split("T")[0];
    if (holidays.find((h) => h.date === iso))
      return (
        <div className="text-[#ef4444] text-[9px] leading-tight">
          {holidays.find((h) => h.date === iso).name}
        </div>
      );
    if (exams.find((e) => e.date === iso))
      return (
        <div className="text-[#3b82f6] text-[9px] leading-tight">
          {exams.find((e) => e.date === iso).name}
        </div>
      );
    if (monthlyTests.includes(iso))
      return (
        <div className="text-[#22c55e] text-[9px] leading-tight">
          Monthly Test
        </div>
      );
    return null;
  };

  return (
    <section className="relative min-h-screen pt-36 md:pt-40 pb-20 px-6 md:px-16 md:pt-[96px] overflow-hidden">
      <div
        className="absolute top-0 left-0 w-96 h-96 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(99,102,241,0.07) 0%, transparent 70%)",
        }}
      />

      <style>{`
        .react-calendar {
          background: rgba(4, 11, 31, 0.8) !important;
          border: 1px solid rgba(244,200,66,0.2) !important;
          border-radius: 12px !important;
          font-family: Nunito, sans-serif !important;
          color: #f0f5ff !important;
          width: 100% !important;
        }
        .react-calendar__navigation button {
          color: #f4c842 !important;
          font-family: Cinzel, serif !important;
          font-size: 0.85rem !important;
        }
        .react-calendar__navigation button:hover,
        .react-calendar__navigation button:focus {
          background: rgba(244,200,66,0.1) !important;
          border-radius: 6px !important;
        }
        .react-calendar__month-view__weekdays__weekday abbr {
          color: #8899b8 !important;
          text-decoration: none !important;
          font-family: Nunito, sans-serif !important;
          font-size: 0.75rem !important;
        }
        .react-calendar__tile {
          color: #f0f5ff !important;
          font-family: Nunito, sans-serif !important;
          font-size: 0.8rem !important;
          border-radius: 6px !important;
        }
        .react-calendar__tile:hover {
          background: rgba(244,200,66,0.12) !important;
        }
        .react-calendar__tile--active {
          background: rgba(244,200,66,0.25) !important;
          border: 1px solid rgba(244,200,66,0.5) !important;
        }
        .react-calendar__tile--now {
          background: rgba(99,102,241,0.2) !important;
        }
        .react-calendar__month-view__days__day--neighboringMonth {
          color: rgba(136,153,184,0.4) !important;
        }
      `}</style>

      <div className="max-w-6xl mx-auto relative z-10">
        <Link
          to="/information"
          className="inline-block text-sm font-bold tracking-wide mb-8"
          style={{ fontFamily: "Nunito, sans-serif", color: "#f4c842" }}
        >
          ← Back to Information
        </Link>

        <h1
          className="uppercase mb-4"
          style={{
            fontFamily: "Orbitron, sans-serif",
            fontWeight: 900,
            fontSize: "clamp(1.8rem, 4vw, 3rem)",
            color: "#f0f5ff",
          }}
        >
          Academic Calendar 2025
        </h1>
        <div className="cosmic-divider mb-10" />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {/* Calendar */}
          <div>
            <CalendarLib
              onChange={setDate}
              value={date}
              tileContent={getTileContent}
              showNeighboringMonth={false}
            />
            {/* Legend */}
            <div
              className="mt-6 flex gap-6 flex-wrap"
              style={{
                fontFamily: "Nunito, sans-serif",
                color: "#8899b8",
                fontSize: "0.85rem",
              }}
            >
              <div className="flex items-center gap-2">
                <span
                  className="w-3 h-3 rounded-full inline-block"
                  style={{ background: "#ef4444" }}
                />
                Holiday
              </div>
              <div className="flex items-center gap-2">
                <span
                  className="w-3 h-3 rounded-full inline-block"
                  style={{ background: "#3b82f6" }}
                />
                Exam
              </div>
              <div className="flex items-center gap-2">
                <span
                  className="w-3 h-3 rounded-full inline-block"
                  style={{ background: "#22c55e" }}
                />
                Monthly Test
              </div>
            </div>
          </div>

          {/* Timeline */}
          <div>
            <h2
              className="mb-6 font-bold"
              style={{
                fontFamily: "Cinzel, serif",
                color: "#f0f5ff",
                fontSize: "1.1rem",
              }}
            >
              Exam Timeline
            </h2>
            <div
              className="relative pl-6"
              style={{ borderLeft: "2px solid rgba(99,102,241,0.4)" }}
            >
              <div className="space-y-6">
                {[
                  ...exams,
                  { date: "monthly", name: "Monthly Tests", isMonthly: true },
                ].map((exam, i) => (
                  <div key={i} className="relative">
                    <div
                      className="absolute -left-[22px] top-2 w-4 h-4 rounded-full border-2"
                      style={{
                        background: "#6366f1",
                        borderColor: "rgba(2,8,16,1)",
                      }}
                    />
                    <div
                      className="glass-card p-4 transition-all duration-300 hover:scale-[1.01]"
                      style={{ borderColor: "rgba(99,102,241,0.25)" }}
                    >
                      <h3
                        className="font-semibold mb-1"
                        style={{
                          fontFamily: "Cinzel, serif",
                          color: "#f0f5ff",
                          fontSize: "0.9rem",
                        }}
                      >
                        {exam.name}
                      </h3>
                      <p
                        style={{
                          fontFamily: "Nunito, sans-serif",
                          color: "#8899b8",
                          fontSize: "0.82rem",
                        }}
                      >
                        {exam.isMonthly
                          ? "Occurs on the 10th of every month"
                          : new Date(exam.date).toLocaleDateString("en-IN", {
                              day: "numeric",
                              month: "long",
                              year: "numeric",
                            })}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Holidays list */}
            <h2
              className="mt-10 mb-5 font-bold"
              style={{
                fontFamily: "Cinzel, serif",
                color: "#f0f5ff",
                fontSize: "1.1rem",
              }}
            >
              Public Holidays
            </h2>
            <div className="space-y-2">
              {holidays.map((h, i) => (
                <div
                  key={i}
                  className="glass-card px-4 py-3 flex items-center justify-between"
                  style={{ borderColor: "rgba(239,68,68,0.2)" }}
                >
                  <span
                    style={{
                      fontFamily: "Nunito, sans-serif",
                      color: "#f0f5ff",
                      fontSize: "0.85rem",
                    }}
                  >
                    {h.name}
                  </span>
                  <span
                    style={{
                      fontFamily: "Nunito, sans-serif",
                      color: "#ef4444",
                      fontSize: "0.8rem",
                    }}
                  >
                    {new Date(h.date).toLocaleDateString("en-IN", {
                      day: "numeric",
                      month: "short",
                    })}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AcademicCalendar;
